var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurserviceimg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0414 17.1874C17.9865 17.2825 17.9076 17.3614 17.8125 17.4162C17.7175 17.4711 17.6097 17.5 17.5 17.4999H2.49997C2.39031 17.4998 2.28262 17.4709 2.18769 17.416C2.09277 17.3611 2.01396 17.2821 1.95918 17.1872C1.9044 17.0922 1.87558 16.9844 1.87561 16.8748C1.87564 16.7651 1.90452 16.6574 1.95934 16.5624C3.14919 14.5054 4.98278 13.0304 7.12263 12.3312C6.06416 11.7011 5.2418 10.7409 4.78183 9.59821C4.32187 8.45548 4.24972 7.19337 4.57649 6.00568C4.90325 4.81798 5.61085 3.77039 6.59061 3.02378C7.57038 2.27716 8.76815 1.8728 9.99997 1.8728C11.2318 1.8728 12.4296 2.27716 13.4093 3.02378C14.3891 3.77039 15.0967 4.81798 15.4235 6.00568C15.7502 7.19337 15.6781 8.45548 15.2181 9.59821C14.7581 10.7409 13.9358 11.7011 12.8773 12.3312C15.0172 13.0304 16.8508 14.5054 18.0406 16.5624C18.0956 16.6574 18.1246 16.7651 18.1247 16.8748C18.1249 16.9845 18.0961 17.0923 18.0414 17.1874Z",
    fill: "#1D6DC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurserviceimg5);
export default __webpack_public_path__ + "static/media/ourserviceimg5.dc6342f2bce07658198ddbce0589b727.svg";
export { ForwardRef as ReactComponent };